/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Quick_Workout_OfflineInputs */

const en_us2_quick_workout_offline = /** @type {(inputs: Quick_Workout_OfflineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offline. The quick workout is built on the server; try again when you have signal.`)
};

const pt_br2_quick_workout_offline = /** @type {(inputs: Quick_Workout_OfflineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sem conexão. O treino rápido é montado no servidor; tente quando o sinal voltar.`)
};

const es_419_quick_workout_offline = /** @type {(inputs: Quick_Workout_OfflineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sin conexión. El entrenamiento rápido se arma en el servidor; intenta cuando vuelva la señal.`)
};

const pt_pt2_quick_workout_offline = /** @type {(inputs: Quick_Workout_OfflineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sem ligação. O treino rápido é montado no servidor; tenta quando o sinal voltar.`)
};

const fr_fr2_quick_workout_offline = /** @type {(inputs: Quick_Workout_OfflineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hors ligne. La séance rapide est créée sur le serveur ; réessaie quand tu auras du réseau.`)
};

const de_de2_quick_workout_offline = /** @type {(inputs: Quick_Workout_OfflineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offline. Das Schnelltraining wird auf dem Server erstellt; versuch es wieder, wenn du Empfang hast.`)
};

const it_it2_quick_workout_offline = /** @type {(inputs: Quick_Workout_OfflineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sei offline. L'allenamento rapido viene creato sul server; riprova quando torna il segnale.`)
};

/**
* | output |
* | --- |
* | "Offline. The quick workout is built on the server; try again when you have signal." |
*
* @param {Quick_Workout_OfflineInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const quick_workout_offline = /** @type {((inputs?: Quick_Workout_OfflineInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Quick_Workout_OfflineInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_quick_workout_offline(inputs)
	if (locale === "es-419") return es_419_quick_workout_offline(inputs)
	if (locale === "pt-PT") return pt_pt2_quick_workout_offline(inputs)
	if (locale === "fr-FR") return fr_fr2_quick_workout_offline(inputs)
	if (locale === "de-DE") return de_de2_quick_workout_offline(inputs)
	if (locale === "it-IT") return it_it2_quick_workout_offline(inputs)
	return en_us2_quick_workout_offline(inputs)
});
export { quick_workout_offline as "quick-workout.offline" }